import { render } from "./WNWhitelist.vue?vue&type=template&id=72b12ec4&scoped=true"
import script from "./WNWhitelist.vue?vue&type=script&lang=js"
export * from "./WNWhitelist.vue?vue&type=script&lang=js"

import "./WNWhitelist.vue?vue&type=style&index=0&id=72b12ec4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-72b12ec4"

export default script